import { Button } from '@mui/material';
import styles from './Header.module.css';
import { redirectToWebUploader } from '../../services/WebUploaderService';
import { useAppSelector } from '../../app/hooks';
import { selectWebUploaderLink } from '../../app/slices/configsSlice';

const WebUploaderLink = () => {
  const uploaderLink = useAppSelector(selectWebUploaderLink);
  return (
    <>
      {!!uploaderLink && (
        <div className={styles.headerMenuItem}>
          <Button onClick={() => redirectToWebUploader(uploaderLink)}>
            Web Uploader
          </Button>
        </div>
      )}
    </>
  );
};

export default WebUploaderLink;
